import { render, staticRenderFns } from "./shelvesExam.vue?vue&type=template&id=77fae7d9"
import script from "./shelvesExam.vue?vue&type=script&lang=js"
export * from "./shelvesExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports